import { useQuery } from '@tanstack/react-query'
import { apis } from '@/modules/apiClients'

export const adminUserDetailsQueryKey = (userId: string) => ['adminUserDetails', userId] as const

export const useUserDetails = (userId: string, options?: { enabled?: boolean }) => {
  const query = useQuery({
    queryKey: adminUserDetailsQueryKey(userId),
    enabled: (options?.enabled ?? true) && !!userId,
    queryFn: async () => {
      const response = await apis.userService.adminUserDetailsId(userId)
      return response.data
    },
  })
  return {
    details: query.data,
    user: query.data?.user,
    challenges: query.data?.challenges,
    assignments: query.data?.assignments,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  }
}
